import { alpha, Theme } from '@mui/material';

export default {
    termSection: {
        borderBottom: ' 1px solid',
        borderColor: (theme: Theme) => alpha(theme.palette.text.primary, 0.08),
        py: 0.25,
        width: '100%',
        flexDirection: 'row',
    },
    termSectionHeader: {
        fontWeight: 600,
        alignItems: 'start',
        flexDirection: 'row',
        whiteSpace: 'nowrap',
        lineHeight: '20px',
    },
    iconHolder: {
        height: '16px',
        minWidth: '16px',
        mr: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginTop: 0.25,
        fontWeight: '400',
    },
    termSectionItems: {
        ml: -0.25,
        pl: '16px',
        width: '100%',
        gap: '2px',
        overflow: 'hidden',
    },
    topicItem: {
        lineHeight: '20px',
        fontSize: '12px',
        borderRadius: '3px',
        '&.none-default': {
            color: (theme: Theme) => alpha(theme.palette.text.primary, 0.64),
            pointerEvents: 'none',
        },
    },
    topicExpandCollapseButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        height: '20px',
        px: 0.5,
        ml: 1,
        color: 'primary.main',
        cursor: 'pointer',
        borderRadius: '3px',
        userSelect: 'none',
        '&:hover': {
            backgroundColor: (theme: Theme) => alpha(theme.palette.primary.main, 0.08),
        },
    },
};
